module.exports = __webpack_public_path__ + "img/taxcertificatehongkong.c49fbccb.png";